// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev ENVIRONMENT which uses `ENVIRONMENT.ts`, but if you do
// `ng build --env=prod` then `ENVIRONMENT.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular.json`.
declare var window: any;
let OBJ_date = new Date(),
	getParameterByName = (name) => {
		name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
		let regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
			results = regex.exec(location.search);
		return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
	},
	consoleLog = () => {
		return getParameterByName("log") == 'true';
	},
	BOO_log = consoleLog(),
	getLocation = () => {
		let ARR_parts = window.location.hostname.split('.'),
			BOO_subdomain = ARR_parts[0].match(/dev|www|preview/),
			STR_subdomain = BOO_subdomain ? ARR_parts.shift() : '';
		return {
			subdomain: STR_subdomain
		};
	},
	OBJ_location = getLocation();

if (!BOO_log) {
	console.log = function(){};
}

export const ENVIRONMENT = {
    production: true,
	env: 'production',
    location: OBJ_location,
    config_path: "/gauntlet/config.json",
	fingerprint: null,
	helper: {
		config: null,
		access: null,
		client: null,
		current_user: null,
		navigation: null
	},
	log: BOO_log,
	modal_options: {
		animated: true,
		keyboard: true,
		backdrop: true,
		ignoreBackdropClick: true,
		class: "tig-modal-dialog"
	},
	sentry_dns: 'https://4d24dfb314524014a3a92bd7b52be2b9@sentry.vogel.de/30',
	patterns: null
};
